import { Col, Span } from 'components'
import { Controller } from 'react-hook-form'
import { COLORS } from 'utils'

import {
  FormControlStyled,
  FormControlLabelStyled,
  RadioGroupStyled,
  RadioStyled,
  IFormControl,
  InputLabelCustom
} from './RadioGroup.styles'
type RadioObject = {
  value: string | number | boolean
  label: string
}
interface IRadioGroup extends IFormControl {
  listOptions: RadioObject[]
  row?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  formValue?: string
  value?: string | number | boolean
  defaultValue?: string | number | boolean
  label?: string
  control?: any
  errors?: any
  labelMenu?: string
  valueMenu?: string | number
  disabled?: boolean
}

export const RadioGroup = ({
  row = false,
  listOptions,
  control,
  errors,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  onChange,
  formValue,
  value,
  defaultValue,
  label = '',
  labelMenu = 'label',
  valueMenu = 'value',
  disabled = false
}: IRadioGroup) => {
  const hasError = errors && errors[formValue]
  return (
    <Col
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
    >
      <InputLabelCustom error={hasError}>{label}</InputLabelCustom>
      <FormControlStyled>
        {control ? (
          <Controller
            control={control}
            name={formValue}
            defaultValue={defaultValue}
            render={({ field }) => (
              <RadioGroupStyled
                row={row}
                onChange={field.onChange}
                value={field.value}
              >
                {listOptions.map((opt, index) => (
                  <FormControlLabelStyled
                    disabled={disabled}
                    key={`${index}-radio-item`}
                    value={opt[valueMenu]}
                    control={<RadioStyled />}
                    label={opt[labelMenu]}
                  />
                ))}
              </RadioGroupStyled>
            )}
          />
        ) : (
          <RadioGroupStyled
            row={row}
            onChange={onChange}
            name={formValue}
            value={value}
            defaultValue={defaultValue}
          >
            {listOptions.map((opt, index) => (
              <FormControlLabelStyled
                disabled={disabled}
                key={`${opt.value}-${index}-radio-item`}
                value={opt.value}
                control={<RadioStyled />}
                label={opt.label}
              />
            ))}
          </RadioGroupStyled>
        )}
        {!!hasError && (
          <Span
            text={errors[formValue]?.message || 'Erro'}
            color={COLORS.error}
          />
        )}
      </FormControlStyled>
    </Col>
  )
}
